export default {
    title: '现有技术',
    add: '添加现有技术',
    searchPlaceholder: '搜索专利...',
    noResults: '未找到现有技术',
    searchHint: '添加专利以跟踪相关现有技术',
    viewDetails: '查看专利详情',
    moreResults: '更多现有技术',
    delete: '删除',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    dialog: {
        title: '添加现有技术',
        subtitle: '按专利号搜索或描述发明内容。',
        placeholder: '例如 US20230123456 或描述发明：\'一种采用弹簧臂的自定心对准机构的光纤连接器...\'',
        proTip: '专业提示：粘贴完整段落可获得更好的语义匹配效果。',
        search: '搜索',
        searching: '搜索中...',
        found: '找到',
        results: '条结果',
        enterQuery: '输入查询开始搜索',
        noResults: '未找到匹配的专利',
        resultsWillAppear: '搜索结果将显示在此处',
        searchFailed: '搜索失败，请稍后重试',
        selected: '已选择',
        cancel: '取消',
        addSelected: '添加所选',
        noSelected: '请至少选择一个专利',
        addSuccess: '成功添加 {count} 个专利',
        addFailed: '添加专利失败，请重试',
    },
};
